import { Component, OnInit } from '@angular/core';
import {
    BlockBreadcrumbsComponent as _BlockBreadcrumbsComponent,
    AuthService,
    PageService,
    ParserService,
    ZoneService,
} from '@gallaghercp/core-frontend';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'core-block-breadcrumbs',
    templateUrl: './block-breadcrumbs.component.html',
})
export class BlockBreadcrumbsComponent extends _BlockBreadcrumbsComponent implements OnInit {
    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected override pages: PageService,
        protected override zone: ZoneService,
        protected router: Router,
    ) {
        super(parser, auth, pages, zone);
    }

    navigateToPage(link: string) {
        if (link.indexOf('#') > -1) {
            // Contains HASH!
            const urlArray = link.split('#');
            this.router.navigate([urlArray[0]], { fragment: urlArray[1] });
        } else {
            // No Hash, proceed as usual
            this.router.navigate([link]);
        }
    }
}
